function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" {...props}><path d="M98 88l12-9-48-17 3.542 10H32.236l6.113-12.227L94 56l11-40H25.976L21.2 0H0v4h18.2l16.336 54.455L25.764 76h41.194L79 110l9-12 13 14 11-11-14-13zM27.176 20h72.576l-8.855 32.201-52.983 3.592L27.176 20zm60.497 71.769l-7.394 9.859L68.571 68.57l33.058 11.708-9.859 7.394 14.467 13.434-5.13 5.13-13.434-14.467z" /><path d="M44 80c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" /></svg>;
});